import { Component, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { ScriptService } from 'apps/driver-dashboardfe/src/app/core/services/script/script.service';
import { scripts } from 'apps/driver-dashboardfe/src/app/shared/constants/script.constant';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';
import { resetUserToken } from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-waitlist-demand',
    templateUrl: './waitlist-demand.component.html',
    styleUrls: ['./waitlist-demand.component.scss'],
})
export class WaitlistDemandComponent implements OnInit {
    email: string = '';
    referredBy: string = '';
    userData$ = new Subscription();
    adlibTag: any;
    fbPixelUs: any;
    fbPixelUsNoScript: any;
    fbPixelCanada: any;
    fbPixelCanadaNoScript: any;

    constructor(
        private joinService: JoinService,
        private renderer: Renderer2,
        private scriptService: ScriptService
    ) {}

    ngOnInit(): void {
        resetUserToken();
        if (environment.production && environment.shouldAddPixel) {
            // pixel scripts
            this.adlibTag = this.scriptService.loadJsScript(
                this.renderer,
                scripts.adlib
            );
            this.fbPixelUs = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-us']
            );
            this.fbPixelUsNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-us']
            );
            this.fbPixelCanada = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-canada']
            );
            this.fbPixelCanadaNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-canada']
            );
        }

        this.userData$ = this.joinService
            .getUserData()
            .subscribe((data: any) => {
                this.email = data?.email;
            });
    }
    ngOnDestroy(): void {
        this.userData$.unsubscribe();
        if (environment.production && environment.shouldAddPixel) {
            this.scriptService.removeScript(this.renderer, this.adlibTag);
            this.scriptService.removeScript(this.renderer, this.fbPixelUs);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelUsNoScript
            );
            this.scriptService.removeScript(this.renderer, this.fbPixelCanada);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelCanadaNoScript
            );
        }
    }
}
